(ns teamoesterreich.user-mode.wana-help.online.helping-online
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.check :refer [check]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.person :refer [person]]
    [reagent-material-ui.icons.rowing :refer [rowing]]
    [reagent.core :as r]

    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    ))



(defn needs-login []
  [mui/grid
   {:container false
    :item      true
    :xs        12                                           ;extra-small: 0px
    :style     #js {:padding "15px"}
    }
   [:h1
    "Nicht angemeldet"]
   [:div
    [:div {:style {}}
     (txt/txt :helping "Du must im angemeldet sein um mitmachen zu können!")]
    [mui/button
     {:variant "outlined"
      :color   "secondary"
      :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}
      :onClick #(a/open-login)
      }
     "Ich will mich anmelden"]]]
  )



(defn get-it []
  (let [!status-online (r/cursor store/app-state [:actual-user :status-online])
        !request-online (r/cursor store/app-state [:actual-user :request-online])
        !actual-user (r/cursor store/app-state [:actual-user])
        request-online-fn #(a/set-user-details {:request-online true :status-online true})
        request-out-online-fn #(a/set-user-details {:request-online false :status-online false})
        !warnings-text (r/cursor store/app-state [:actual-user :wanado-warnings :online-text])
        !warnings-level (r/cursor store/app-state [:actual-user :wanado-warnings :online-level])

        ]
    (a/set-bottom-action-fn #(a/set-page-back))
    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:container false
       :item      true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :item      true
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1
          "Online Helfen"]
         [:span
          "Mit dem Smartphone helfen. Informationen weiterleiten; Rückmeldungen geben; Fotos schicken, die uns helfen, die Lage zu beurteilen ..."]
         ]



        (when (not (:tom-id @!actual-user))
          [needs-login !actual-user])

        (when (and (:tom-id @!actual-user) (not @!request-online))
          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     #js {:padding "15px"}
            }
           [:h1
            "Voraussetzungen"]



           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             [check]]
            [:div {:class "check-line-text"}
             "Ausgefülltes persönliches Profil"]
            [mui/button {:variant   "outlined"
                         :color     "primary"
                         :startIcon (r/as-element [person])
                         :onClick   #(a/set-page :wanaHelpOnline-profile-personal)
                         }
             "Profil"]
            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             [check]]
            [:div {:class "check-line-text"}
             "`Online Aktivitäten` aktiviert unter `Was ich tun möchte`"]
            [mui/button {:variant   "outlined"
                         :color     "primary"
                         :startIcon (r/as-element [rowing])
                         :onClick   #(a/set-page :wanaHelpOnline-profile-devices)
                         }
             "Meine Geräte"]
            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             [check]]
            [:div {:class "check-line-text"}
             "App installiert und mit diesem User verbunden "]
            [:br]
            [:span {:style {:color "#666" :marginLeft "30px"}} "Zum Installieren der App kannst du die Store-Links unten verwenden."]
            ]

           ]
          )

        (when (and (:tom-id @!actual-user) @!request-online)
          [mui/grid
           {:container false
            :item      true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     #js {:padding "15px"}
            }
           [mui/button
            {:variant "outlined"
             :color   "secondary"
             :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}

             }
            "Ich helfe schon"]


           [mui/button
            {:variant "outlined"
             :style   #js {:margin "10px 0 10px 10px" :min-width "200px" :float "right"}
             :onClick #(request-out-online-fn)
             }
            "Abmelden"]])

        (when (and (:tom-id @!actual-user) (not @!request-online))

          [mui/grid
           {:container false
            :item      true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     #js {:padding "15px"}
            }
           [mui/button
            {:variant "outlined"
             :color   "secondary"
             :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}
             :onClick #(request-online-fn)

             }
            "Ich will online helfen."]]

          )

        (when (and (:tom-id @!actual-user) @!request-online)
          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     #js {:padding "15px"}
            }
           [:h1
            "Voraussetzungen"]
           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             [check]]
            [:div {:class "check-line-text"}
             "App installiert und mit diesem User verbunden "]
            [mui/button {:variant   "outlined"
                         :color     "primary"
                         :startIcon (r/as-element [rowing])
                         :onClick   #(a/set-page :wanaHelpOnline-profile-devices)
                         }
             "Meine Geräte"]
            [:br]
            [:span {:style {:color "#666" :marginLeft "30px"}} "Zum Installieren der App kannst du die Store-Links unten verwenden."]

            ]
           (when false
             [:h1
              "Meine letzten/aktuellen Einsätze als Digitalhelfer"])
           (when false
             [:p "kein Einsatz!"])

           ])

        (when-not (and (:tom-id @!actual-user) (= "" (or (txt/txt :helping "Online-IosApp") "")))
          [mui/grid
           {:container false
            :item      true
            :md        5                                    ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:a
            {:href (txt/txt :helping "Online-IosApp")}
            [:img {:alt "Itunes App " :src "/custom/img/apsStoresIos.png"}]
            ]

           ])


        [mui/grid
         {:container false
          :item      true
          :md        5                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:a
          {:href (txt/txt :helping "Online-AndroidApp")}
          [:img {:alt "Android App " :src "/custom/img/apsStoresAndroid.png"}]
          ]

         ]


        [mui/grid
         {:container false
          :item      true
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :style     {:margin "10px 0 10px 10px" :width "200px"}
           :onClick   #(a/set-page-back)
           :startIcon (r/as-element [keyboard-arrow-left])
           }
          "Zurück"]]

        ]]]]
    ))


